module.exports = __webpack_public_path__ + "img/icon_warning.6bb937d7.png";